import loadable from '@loadable/component';

import { withEmojiData } from 'Shared/utils/withEmojiData';

const EmojiNimblePicker = loadable(() =>
  import(/* webpackPrefetch: true */ 'emoji-mart/dist/components/picker/nimble-picker')
);
const EmojiNimble = loadable(() => import(/* webpackPrefetch: true */ 'emoji-mart/dist/components/emoji/nimble-emoji'));

export const EmojiPicker = withEmojiData(EmojiNimblePicker);
export const Emoji = withEmojiData(EmojiNimble);
